import { cn } from '@/utils';
import { FeedbackSection as FeedbackSectionType, FeedbackItem } from '../ScoreRowCard.types';
import { scoreRowCardStyles } from '../ScoreRowCard.styles';
import { SkeletonLoader } from '@/components/Loaders';
import { TScoreType } from '@/types';
import React from 'react';

/** Props for the ScoreRowCardFeedbackSection component */
export interface ScoreRowCardFeedbackSectionProps {
  /** The feedback sections to display */
  feedback?: FeedbackSectionType[];
  /** Whether the data is still loading */
  isLoading?: boolean;
  /** The type of score row card */
  type?: TScoreType;
  /** The visible feedback sections (after pagination/truncation) */
  visibleFeedback?: FeedbackSectionType[];
}

/** Renders the feedback section of the ScoreRowCard */
export const ScoreRowCardFeedbackSection: React.FC<ScoreRowCardFeedbackSectionProps> = ({
  feedback = [],
  isLoading,
  type,
  visibleFeedback = [],
}) => {
  if (isLoading) {
    return (
      <div>
        <SkeletonLoader className="mb-2 h-5 w-28" />
        <div className="space-y-1">
          <SkeletonLoader className="h-5 w-full" />
          <SkeletonLoader className="h-5 w-full" />
          <SkeletonLoader className="h-5 w-5/6" />
        </div>
      </div>
    );
  }

  if (type === 'violation') {
    return (
      <div className={scoreRowCardStyles.feedbackSection}>
        {feedback.map((section, idx) => (
          <div key={section?.title || idx}>
            {section?.title && (
              <p
                className={cn(scoreRowCardStyles.feedbackTitle, {
                  [scoreRowCardStyles.feedbackTitleWithViolation]: type === 'violation',
                })}
              >
                {section.title}
              </p>
            )}
            {section?.items?.length !== 0 && (
              <ul className={scoreRowCardStyles.feedbackList}>
                {section.items.map((item: FeedbackItem, i: number) => (
                  <li key={i} className={scoreRowCardStyles.feedbackItem}>
                    {item.text}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    visibleFeedback.length > 0 && (
      <div className={scoreRowCardStyles.feedbackSection}>
        {visibleFeedback.map((section, idx) => (
          <div key={section?.title || idx}>
            {section?.title && (
              <p className={scoreRowCardStyles.feedbackTitle}>{section.title}</p>
            )}

            {section?.items?.length !== 0 && (
              <ul className={scoreRowCardStyles.feedbackList}>
                {section.items.map((item: FeedbackItem, i: number) => (
                  <li key={i} className={scoreRowCardStyles.feedbackItem}>
                    {item.text}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    )
  ) as React.ReactElement | null;
};

ScoreRowCardFeedbackSection.displayName = 'ScoreRowCardFeedbackSection';

export default ScoreRowCardFeedbackSection;
